// extracted by mini-css-extract-plugin
var _1 = "Popup_closeButton__LQ+BJ";
var _2 = "Popup_popup__SxMIp";
export { _1 as "closeButton", _2 as "popup" }
